import { SET_BULK_BALANCE, CLEAR_PARAMS_BALANCE, SET_PARAMS_BALANCE } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    composer_id: "",
    startDate: "",
    endDate: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_BALANCE:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_BALANCE:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_BALANCE:
            return initialState;
        default:
            return state;
    }
}
